<template>
  <div>
    <v-container class="py-0 px-0">
      <v-card tile>
        <v-card-title>Berita Acara Dikirim</v-card-title>
        <v-card-text class="py-0">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Tgl Kirim BA"
                  dense
                  hide-details
                  type="date"
                  v-model="formData.tgl_kirim_ba"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="fit-content">
                <v-combobox
                  v-model="formData.ttpb_list"
                  label="No TTPB (bisa pilih beberapa)"
                  multiple
                  small-chips
                  deletable-chips
                  dense
                  hide-details
                  :items="ttpbOptions"
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-btn
                  color="primary"
                  :loading="loading.saveData"
                  :disabled="loading.saveData"
                  @click="saveData"
                  small
                >
                  Simpan
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <v-data-table
        :headers="dataHeaders"
        :items="data"
        :loading="loading.fetchData"
        :items-per-page="10"
        class="elevation-1 mt-2"
        dense
      >
        <template v-slot:item.tgl_ba_kembali="{ item }">
          {{ item.tgl_ba_kembali || "-" }}
        </template>
        <template v-slot:item.tgl_kirim_ba="{ item }">
          {{ item.tgl_kirim_ba || "-" }}
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BeritaAcaraDikirim",
  data() {
    return {
      loading: {
        saveData: false,
        fetchData: false
      },
      formData: {
        tgl_kirim_ba: "",
        ttpb_list: []
      },
      ttpbOptions: [],
      dataHeaders: [
        { text: "Kode TTB", value: "kodettb" },
        { text: "Tgl BA Kembali", value: "tgl_ba_kembali" },
        { text: "Tgl Kirim BA", value: "tgl_kirim_ba" },
        { text: "Keterangan", value: "keterangan_ba" }
      ],
      data: []
    };
  },
  methods: {
    async fetchData() {
      this.loading.fetchData = true;

      await axios
        .get(`berita-acara?has_ba=1`)
        .then(res => {
          this.data = res.data;
          this.loading.fetchData = false;
        })
        .catch(err => {
          this.loading.fetchData = false;
          alert(err.response.data.message);
        });
    },
    async fetchTTPBOptions() {
      await axios
        .get(`berita-acara/pending-kirim`)
        .then(res => {
          this.ttpbOptions = res.data.map(item => item.kodettb);
        })
        .catch(() => {});
    },
    async saveData() {
      if (!this.formData.tgl_kirim_ba || this.formData.ttpb_list.length === 0) {
        alert("Tgl Kirim BA dan minimal 1 No TTPB harus diisi");
        return;
      }

      this.loading.saveData = true;

      await axios
        .post(`berita-acara/update-dikirim`, this.formData)
        .then(res => {
          this.loading.saveData = false;
          this.fetchData();
          this.fetchTTPBOptions();
          this.resetFormData();
        })
        .catch(err => {
          this.loading.saveData = false;
          alert(err.response.data.message);
        });
    },
    resetFormData() {
      this.formData.tgl_kirim_ba = "";
      this.formData.ttpb_list = [];
    }
  },
  created() {
    this.fetchData();
    this.fetchTTPBOptions();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}
</style>
